import { Modal } from 'antd'
import React from 'react'
import { IoMdCheckmark } from 'react-icons/io'

const NewsLetterSuccessModal = ({ onCloseModal, isOpen }) => {
   return (
      <Modal
         className="relative w-full max-w-[400px] p-2"
         open={isOpen}
         footer=""
         centered
         onCancel={onCloseModal}
         maskClosable={false}>
         <div className="flex w-full flex-col items-center justify-center p-2 text-center">
            <div className="flex size-16 shrink-0 items-center justify-center rounded-full bg-success-light p-3">
               <IoMdCheckmark className="size-6 shrink-0 text-success" />
            </div>
            <h2 className="mt-6 text-base font-medium text-primary md:text-lg lg:text-xl xl:text-2xl">
               Terima kasih! Email Anda telah berhasil terdaftar.
            </h2>
            <p className="mt-4 text-center text-xs font-normal text-secondary lg:text-sm xl:text-base">
               Kami akan mengirimkan pembaruan terbaru tentang penawaran dan wawasan langsung ke
               kotak masuk Anda.
            </p>
         </div>
      </Modal>
   )
}

export default NewsLetterSuccessModal
